// extracted by mini-css-extract-plugin
module.exports = {"container":"RemindCheckBox_container__hYZ32","checkmark":"RemindCheckBox_checkmark__o9qTd"};